import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import { getPhoenixFormVersion } from "requests/homeowner/caseforms";
import MSpinner from "components/Shared/MSpinner.tsx";
import Appraisal1004DesktopV0 from "components/Homeowner/CaseForms/Appraisal1004Desktop/V0/Appraisal1004DesktopV0";
import Appraisal1004DesktopV1 from "components/Homeowner/CaseForms/Appraisal1004Desktop/V1/Appraisal1004DesktopV1";

export const Appraisal1004Desktop = props => {
  const mounted = useRef(true);

  const [version, setVersion] = useState(0);
  const [isFetchingVersion, setIsFetchingVersion] = useState(true);

  useEffect(() => {
    getPhoenixFormVersion(props.controlNumber, (payload) => {
      setVersion(payload);
      setIsFetchingVersion(false);
    }, mounted);
    return (() => { mounted.current = false; });
  }, []);

  if (isFetchingVersion) return <MSpinner />;

  let versionedComponents = [];
  versionedComponents[0] = Appraisal1004DesktopV0;
  versionedComponents[1] = Appraisal1004DesktopV1;
  versionedComponents["PhoenixFormVersionNoneFound"] = Appraisal1004DesktopV0;
  let MyComponent = versionedComponents[version];
  if (!MyComponent) {
    throw new Error(`No corresponding 1004p frontend version for backend version: ${version}`);
  }
  return (<MyComponent
    controlNumber={props.controlNumber}
    onChange={props.onChange}
    onSave={props.onSave}
    readOnly={props.readOnly}
  />);
};

Appraisal1004Desktop.propTypes = {
  controlNumber: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  readOnly: PropTypes.bool
};

export default Appraisal1004Desktop;
